function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = [
    "api",
    "colDef",
    "id",
    "hasFocus",
    "isEditable",
    "field",
    "value",
    "formattedValue",
    "row",
    "rowNode",
    "cellMode",
    "tabIndex",
    "position",
    "focusElementRef"
];
import * as React from 'react';
import PropTypes from 'prop-types';
import MenuList from '@mui/material/MenuList';
import { useRtl } from '@mui/system/RtlProvider';
import { unstable_useId as useId } from '@mui/utils';
import { gridClasses } from "../../constants/gridClasses.js";
import { GridMenu } from "../menu/GridMenu.js";
import { useGridRootProps } from "../../hooks/utils/useGridRootProps.js";
import { useGridApiContext } from "../../hooks/utils/useGridApiContext.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var hasActions = function(colDef) {
    return typeof colDef.getActions === 'function';
};
function GridActionsCell(props) {
    var _rootProps_slotProps;
    var colDef = props.colDef, id = props.id, hasFocus = props.hasFocus, tabIndex = props.tabIndex, _props_position = props.position, position = _props_position === void 0 ? 'bottom-end' : _props_position, focusElementRef = props.focusElementRef, other = _objectWithoutPropertiesLoose(props, _excluded);
    var _React_useState = _sliced_to_array(React.useState(-1), 2), focusedButtonIndex = _React_useState[0], setFocusedButtonIndex = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(false), 2), open = _React_useState1[0], setOpen = _React_useState1[1];
    var apiRef = useGridApiContext();
    var rootRef = React.useRef(null);
    var buttonRef = React.useRef(null);
    var ignoreCallToFocus = React.useRef(false);
    var touchRippleRefs = React.useRef({});
    var isRtl = useRtl();
    var menuId = useId();
    var buttonId = useId();
    var rootProps = useGridRootProps();
    if (!hasActions(colDef)) {
        throw new Error('MUI X: Missing the `getActions` property in the `GridColDef`.');
    }
    var options = colDef.getActions(apiRef.current.getRowParams(id));
    var iconButtons = options.filter(function(option) {
        return !option.props.showInMenu;
    });
    var menuButtons = options.filter(function(option) {
        return option.props.showInMenu;
    });
    var numberOfButtons = iconButtons.length + (menuButtons.length ? 1 : 0);
    React.useLayoutEffect(function() {
        if (!hasFocus) {
            Object.entries(touchRippleRefs.current).forEach(function(param) {
                var _param = _sliced_to_array(param, 2), index = _param[0], ref = _param[1];
                ref === null || ref === void 0 ? void 0 : ref.stop({}, function() {
                    delete touchRippleRefs.current[index];
                });
            });
        }
    }, [
        hasFocus
    ]);
    React.useEffect(function() {
        if (focusedButtonIndex < 0 || !rootRef.current) {
            return;
        }
        if (focusedButtonIndex >= rootRef.current.children.length) {
            return;
        }
        var child = rootRef.current.children[focusedButtonIndex];
        child.focus({
            preventScroll: true
        });
    }, [
        focusedButtonIndex
    ]);
    React.useEffect(function() {
        if (!hasFocus) {
            setFocusedButtonIndex(-1);
            ignoreCallToFocus.current = false;
        }
    }, [
        hasFocus
    ]);
    React.useImperativeHandle(focusElementRef, function() {
        return {
            focus: function() {
                // If ignoreCallToFocus is true, then one of the buttons was clicked and the focus is already set
                if (!ignoreCallToFocus.current) {
                    // find the first focusable button and pass the index to the state
                    var focusableButtonIndex = options.findIndex(function(o) {
                        return !o.props.disabled;
                    });
                    setFocusedButtonIndex(focusableButtonIndex);
                }
            }
        };
    }, [
        options
    ]);
    React.useEffect(function() {
        if (focusedButtonIndex >= numberOfButtons) {
            setFocusedButtonIndex(numberOfButtons - 1);
        }
    }, [
        focusedButtonIndex,
        numberOfButtons
    ]);
    var showMenu = function() {
        setOpen(true);
        setFocusedButtonIndex(numberOfButtons - 1);
        ignoreCallToFocus.current = true;
    };
    var hideMenu = function() {
        setOpen(false);
    };
    var toggleMenu = function(event) {
        event.stopPropagation();
        event.preventDefault();
        if (open) {
            hideMenu();
        } else {
            showMenu();
        }
    };
    var handleTouchRippleRef = function(index) {
        return function(instance) {
            touchRippleRefs.current[index] = instance;
        };
    };
    var handleButtonClick = function(index, onClick) {
        return function(event) {
            setFocusedButtonIndex(index);
            ignoreCallToFocus.current = true;
            if (onClick) {
                onClick(event);
            }
        };
    };
    var handleRootKeyDown = function(event) {
        if (numberOfButtons <= 1) {
            return;
        }
        var getNewIndex = function(index, direction) {
            var _options_;
            if (index < 0 || index > options.length) {
                return index;
            }
            // for rtl mode we need to reverse the direction
            var rtlMod = isRtl ? -1 : 1;
            var indexMod = (direction === 'left' ? -1 : 1) * rtlMod;
            // if the button that should receive focus is disabled go one more step
            return ((_options_ = options[index + indexMod]) === null || _options_ === void 0 ? void 0 : _options_.props.disabled) ? getNewIndex(index + indexMod, direction) : index + indexMod;
        };
        var newIndex = focusedButtonIndex;
        if (event.key === 'ArrowRight') {
            newIndex = getNewIndex(focusedButtonIndex, 'right');
        } else if (event.key === 'ArrowLeft') {
            newIndex = getNewIndex(focusedButtonIndex, 'left');
        }
        if (newIndex < 0 || newIndex >= numberOfButtons) {
            return; // We're already in the first or last item = do nothing and let the grid listen the event
        }
        if (newIndex !== focusedButtonIndex) {
            event.preventDefault(); // Prevent scrolling
            event.stopPropagation(); // Don't stop propagation for other keys, for example ArrowUp
            setFocusedButtonIndex(newIndex);
        }
    };
    var handleListKeyDown = function(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
        }
        if ([
            'Tab',
            'Escape'
        ].includes(event.key)) {
            hideMenu();
        }
    };
    return /*#__PURE__*/ _jsxs("div", _extends({
        role: "menu",
        ref: rootRef,
        tabIndex: -1,
        className: gridClasses.actionsCell,
        onKeyDown: handleRootKeyDown
    }, other, {
        children: [
            iconButtons.map(function(button, index) {
                return /*#__PURE__*/ React.cloneElement(button, {
                    key: index,
                    touchRippleRef: handleTouchRippleRef(index),
                    onClick: handleButtonClick(index, button.props.onClick),
                    tabIndex: focusedButtonIndex === index ? tabIndex : -1
                });
            }),
            menuButtons.length > 0 && buttonId && /*#__PURE__*/ _jsx(rootProps.slots.baseIconButton, _extends({
                ref: buttonRef,
                id: buttonId,
                "aria-label": apiRef.current.getLocaleText('actionsCellMore'),
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-controls": open ? menuId : undefined,
                role: "menuitem",
                size: "small",
                onClick: toggleMenu,
                touchRippleRef: handleTouchRippleRef(buttonId),
                tabIndex: focusedButtonIndex === iconButtons.length ? tabIndex : -1
            }, (_rootProps_slotProps = rootProps.slotProps) === null || _rootProps_slotProps === void 0 ? void 0 : _rootProps_slotProps.baseIconButton, {
                children: /*#__PURE__*/ _jsx(rootProps.slots.moreActionsIcon, {
                    fontSize: "small"
                })
            })),
            menuButtons.length > 0 && /*#__PURE__*/ _jsx(GridMenu, {
                open: open,
                target: buttonRef.current,
                position: position,
                onClose: hideMenu,
                children: /*#__PURE__*/ _jsx(MenuList, {
                    id: menuId,
                    className: gridClasses.menuList,
                    onKeyDown: handleListKeyDown,
                    "aria-labelledby": buttonId,
                    variant: "menu",
                    autoFocusItem: true,
                    children: menuButtons.map(function(button, index) {
                        return /*#__PURE__*/ React.cloneElement(button, {
                            key: index,
                            closeMenu: hideMenu
                        });
                    })
                })
            })
        ]
    }));
}
process.env.NODE_ENV !== "production" ? GridActionsCell.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    api: PropTypes.object,
    /**
   * The mode of the cell.
   */ cellMode: PropTypes.oneOf([
        'edit',
        'view'
    ]).isRequired,
    /**
   * The column of the row that the current cell belongs to.
   */ colDef: PropTypes.object.isRequired,
    /**
   * The column field of the cell that triggered the event.
   */ field: PropTypes.string.isRequired,
    /**
   * A ref allowing to set imperative focus.
   * It can be passed to the element that should receive focus.
   * @ignore - do not document.
   */ focusElementRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({
            current: PropTypes.shape({
                focus: PropTypes.func.isRequired
            })
        })
    ]),
    /**
   * The cell value formatted with the column valueFormatter.
   */ formattedValue: PropTypes.any,
    /**
   * If true, the cell is the active element.
   */ hasFocus: PropTypes.bool.isRequired,
    /**
   * The grid row id.
   */ id: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]).isRequired,
    /**
   * If true, the cell is editable.
   */ isEditable: PropTypes.bool,
    position: PropTypes.oneOf([
        'bottom-end',
        'bottom-start',
        'bottom',
        'left-end',
        'left-start',
        'left',
        'right-end',
        'right-start',
        'right',
        'top-end',
        'top-start',
        'top'
    ]),
    /**
   * The row model of the row that the current cell belongs to.
   */ row: PropTypes.any.isRequired,
    /**
   * The node of the row that the current cell belongs to.
   */ rowNode: PropTypes.object.isRequired,
    /**
   * the tabIndex value.
   */ tabIndex: PropTypes.oneOf([
        -1,
        0
    ]).isRequired,
    /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */ value: PropTypes.any
} : void 0;
export { GridActionsCell };
export var renderActionsCell = function(params) {
    return /*#__PURE__*/ _jsx(GridActionsCell, _extends({}, params));
};
